import { oktaAuth } from '@/lib/auth';

export function getAuthHeaders(): Record<string, string> {
  const authState = oktaAuth.authStateManager.getAuthState();
  if (authState?.isAuthenticated && authState.accessToken?.accessToken) {
    return { Authorization: `Bearer ${authState.accessToken.accessToken}` };
  }
  return {};
}
